package com.parmartechnologies.storage.table.inventory.product_sub_category

import com.parmartechnologies.core.feature.productSubCategory.model.ProductSubCategory
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class ProductSubCategoryDatabaseTable : DatabaseTable() {

    fun insert(item: ProductSubCategory?) {
        item?.let {
            DatabaseCollection().insert(item, ProductSubCategory.serializer())
        }
    }

    fun insert(items: List<ProductSubCategory>?, callback: () -> Unit) {
        items?.let {
            DatabaseCollection().insertAll(items, ProductSubCategory.serializer())
        }
    }

    fun retrieve(id: String, callback: (List<ProductSubCategory>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, ProductSubCategory.serializer()){
            callback(it)
        }
    }

    fun find(id: String, callback: (List<ProductSubCategory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("category_id",id))
        DatabaseCollection().findAll(andQuery, ProductSubCategory.serializer()){
            callback(it)
        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
        callback("")
    }
}